export const BU_MDH = 'C004';
export const BU_SM = 'C001';

export const NOMENCLATORS = {
  NEWS_CATEGORIES: 'NEWS_CATEGORIES',
  TASK_AREAS: 'TASK_AREAS'
};

export const TASK_TYPES = {
  RECEPMER: 'RECEPMER',
  CYCLEINVENTORY: 'CYCLEINVENTORY',
  CYCLEINVENTORYRELEASE: 'CYCLEINVENTORYRELEASE',
  TASKMANAGER: 'TASKMANAGER',
  RACKREVIEW: 'RACKREVIEW',
  LOSSSTATEMENT: 'LOSSSTATEMENT',
  LOSSPLAN: 'LOSSPLAN',
  INTERNAL_CONSUMPTION: 'INTERNALCONSUMPTION',
  INTERNAL_CONSUMPTION_CONTROL: 'INTERNALCONSUMPTIONCONTROL',
  STOCKADJUSTMENT: 'STOCKADJUSTMENT',
  STOCKADJUSTMENTFORAPPROVE: 'STOCKADJUSTMENTFORAPPROVE',
  BREAKADJUSTMENTALERT: 'BREAKADJUSTMENTALERT',
  BREAKADJUSTMENTFORAPPROVE: 'BREAKADJUSTMENTALERTFORAPPROVE'
};

export const Scopes = {
  // RACKREVIEW MANAGER AND SUB MANAGER
  RACKREVIEW_MANAGER: 'rackreview.manager'
}

export const DIGITAL_CHECKLIST_TASK_TYPE = 'CHECKLIST';
export const DIGITAL_CHECKLIST_ITEM_TASK_TYPE = 'CHECKLIST-ITEM';

export const STOCK_ADJUSTMENT_MAX_ALLOWED_HOUR = 21;
export const CYCLE_INENTORY_MAX_ALLOWED_HOUR = 21;
